<div class="modal fade" id="dialogAcesso" tabindex="-1" role="dialog" aria-labelledby="Acesso" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-info text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Acessos</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-12">
                <div class="input-group">
                  <input [(ngModel)]="filtro" (keydown.enter)="onClick()" type="text" class="form-control"
                    placeholder="Informe o usuário ou tipo de movimentação"
                    aria-label="Informe o usuário ou tipo de movimentação" aria-describedby="button-addon2">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" (click)="onClick()" type="button" id="button-addon2">
                      <img src="assets/img/global/zoom.png" alt="localizar" height="20" width="20">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row" *ngIf="listAcessos && listAcessos.length === 0">
              <div class="col-12">
                <i class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></i>
                <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12">
                <table class="table table-eddy" *ngIf="listAcessos && listAcessos.length > 0">
                  <thead>
                    <tr>
                      <th scope="col">Tipo</th>
                      <th scope="col" class="text-center">Data</th>
                      <th scope="col">Sistema</th>
                      <th scope="col">Usuário</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of listAcessos">
                      <td [ngClass]="item.tipo === 'LOGIN' ? 'badge badge-success' : 'badge badge-danger'">
                        {{item.tipo}}</td>
                      <td class="text-center">{{item.data_cadastro | date:'dd/MM/yyyy HH:mm'}}</td>
                      <td>{{globalService.traduzirSistema(item.sistema)}}</td>
                      <td>{{item.usuario.nome}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row float-right">
              <div class="col-12 mb-1">
                <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
                  (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>